import React, { useCallback, useReducer, useMemo } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Divider,
    Typography,
} from '@mui/material';
import { ValidDataService } from '../../../../service/validDataService';
import { isLocalDev } from '../../../../utils/environment';
import useAbortController from '../../../../hooks/useAbortController';
import SelectableTable from '../../../enhancedTable/SelectableTable';

export default function SupplierListDialog({ open, onClose, onSelect, supplierType }) {
    const [signal, abortRequest] = useAbortController();
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        data: [],
        totalRowCount: 0,
        pageCount: 0,
        filter: '',
        loading: false,
    });

    const columns = useMemo(
        () => [
            {
                Header: 'Supplier Name',
                accessor: 'supplierName',
            },
            {
                Header: 'Phone',
                accessor: 'phone1',
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Address',
                accessor: 'address',
            },
            {
                Header: 'Actions',
                accessor: 'actions',
                Cell: ({ row }) => (
                    <Button
                        variant="text   "
                        color="primary"
                        onClick={() => handleSelect(row.original)}
                    >
                        Select
                    </Button>
                ),
            },
        ],
        []
    );

    const fetchData = useCallback(({ pageSize, pageIndex, globalFilter, sortBy }) => {
        const from = pageSize * pageIndex;
        updateState({ loading: true });
        ValidDataService.getValidSupplierrDataWithLimit(from, pageSize, globalFilter, sortBy, supplierType, signal).then(result => {
            const { code, data } = result;
            if (code === 0) {
                updateState({
                    data: data.data,
                    totalRowCount: data.count,
                    pageCount: Math.ceil(data.count / pageSize),
                });
            }
            updateState({ loading: false });
        }).catch(error => {
            if (isLocalDev) {
                console.error(error)
            }
            updateState({ loading: false });
        });
    }, [signal]);

    const handleSelect = (supplier) => {
        onSelect(supplier);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Select Supplier</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography variant="h4">Suppliers</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <SelectableTable
                        columns={columns}
                        data={state.data}
                        totalRowCount={state.totalRowCount}
                        pageCount={state.pageCount}
                        fetchData={fetchData}
                        loading={state.loading}
                        disableSelection={true}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}